import * as React from "react";
import {Component } from "react";

import {observer} from "mobx-react";
import _ from "lodash";
import {Image, List} from "semantic-ui-react";
import {Eingang} from "../../../../models/gebaeude";
import {MapViewerStore} from "../../../../stores/map-viewer-store-mobx";
import {withStore} from "../../../../core/stores/abstract-app-store";

export interface EingangTableProps {
    data: Eingang[];
    handleHighlightClick: (e: React.MouseEvent | undefined, eingang: Eingang | null) => void;
    title?: string;
    store?: MapViewerStore; // this is injected by withStore
}
interface SortAction {
    type: string;
    column: string;
}
@observer
class EingangTableBase extends Component<EingangTableProps, any> {
    watchHandles: any[] = [];
    constructor(props: EingangTableProps) {
        super(props);
        this.state = {
            column: "art",
            data: _.orderBy(this.props.data, ["strasse", "nummer", "plz"], ["asc", "asc", "asc"]),
            direction: "ascending"
        };
        this.sort = this.sort.bind(this);
    }
    sort(action: SortAction): void {
        switch (action.type) {
        case "CHANGE_SORT":
            if (this.state.column === action.column) {
                this.setState({
                    ...this.state,
                    data: this.state.data.reverse(),
                    direction:
                            this.state.direction === "ascending" ? "descending" : "ascending"
                });
            } else {
                this.setState({
                    column: action.column,
                    data: _.sortBy(this.state.data, [action.column]),
                    direction: "ascending",
                });
            }
            return;
        default:
            throw new Error();
        }
    }
    handleHighlightClick(e: React.MouseEvent, eingang: Eingang): void {
        const { store } = this.props;
        if (eingang.edid === store?.oStore.edid){
            this.props.handleHighlightClick(e, null);
            store?.oStore.setEdid(undefined);
        } else {
            this.props.handleHighlightClick(e, eingang);
            store?.oStore.setEdid(eingang.edid);
        }
    }
    componentDidMount(): void {
    }
    componentWillUnmount(): void {
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
    }
    render(): React.ReactElement | null {
        const { data } = this.state;
        const { store } = this.props;
        const edid = store?.oStore.edid;
        if (data === null || data.length === 0){
            return null;
        }
        return (
            <List className={"eingaenge"}>
                {data.map((item: Eingang) => (
                    <List.Item key={item.id}
                        className={((item.edid === edid) ? "highlighted" : "")}
                        onClick={(event: React.MouseEvent) => this.handleHighlightClick(event, item)}>
                        <Image src={store?.mapViewerConfig.pointerSymbols?.eingang.url}
                            height="24" verticalAlign="middle" />
                        {item.strasse} {item.nummer}, {item.plz} {item.ort}
                        <span> ({item.egid}/{item.edid})</span>
                    </List.Item>
                ))}
            </List>
        );
    }
}

export const EingangTable = withStore(EingangTableBase);
